export default "__VITE_PUBLIC_ASSET__0219e177__"